import Vue from 'vue'
import { ServiceCall } from '@/common/api.service'
import { FETCH_SERVICE, FETCH_SERVICES, SERVICE_RESET_STATE } from './actions.type'
import { SET_SERVICE, SET_SERVICES, RESET_STATE_ITEM, RESET_STATE } from './mutations.type'

const initialState = {
  service: {
    id: '',
    name: '',
    description: '',
  },
  services: { content: [] },
  page: 1,
}

export const state = {
  ...initialState,
}

export const actions = {
  /**
   * Get a single service by id
   * @param {*} context
   * @param {*} payload
   */
  async [FETCH_SERVICE](context, payload) {
    //console.log('[Fetching service]: ' + payload)
    const { data } = await ServiceCall.get(payload)
    context.commit(SET_SERVICE, data)
    return data
  },

  async [FETCH_SERVICES](context, payload) {
    // console.log('[Launch search]' + payload)
    await ServiceCall.query(payload.params, payload.canceler).then((response) => {
      context.commit(SET_SERVICES, response.data)
    })
  },

  [SERVICE_RESET_STATE]({ commit }) {
    commit(RESET_STATE)
  },
}

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  // Set collection
  [SET_SERVICE](state, service) {
    return (state.service = service)
  },

  [SET_SERVICES](state, services) {
    return (state.services = services)
  },

  [RESET_STATE_ITEM](state, item) {
    state[item] = initialState[item]
  },
  [RESET_STATE]() {
    for (const f in state) {
      Vue.set(state, f, initialState[f])
    }
  },
}

const getters = {
  service(state) {
    return state.service
  },
  services(state) {
    return state.services
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}

// function RESET_STATE(RESET_STATE) {
//   throw new Error('Function not implemented.')
// }
